<template>
  <div>
    <div>
      <vxe-grid
        ref="table"
        row-id="inspectionDefectCode"
        show-overflow
        highlight-hover-row
        :data="tableData"
        :height="250"
        :columns="tableColumns"
        :edit-rules="validRules"
        row-key
        show-footer
        :footer-method="() => footerData"
        size="small"
        auto-resize
        resizable
        keep-source
        border
        :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      >
        <template v-slot:toolbar_form> </template>
        <template v-slot:subQuantity="{ row }">
          <div>
            <i
              class="el-icon-remove-outline tool-btn"
              style="color: red;"
              @click="subQuantity(row)"
            ></i>
          </div>
        </template>
        <template v-slot:addQuantity="{ row }">
          <div>
            <i
              class="el-icon-circle-plus-outline tool-btn"
              style="color: green;"
              @click="confirm([row])"
            ></i>
          </div>
        </template>
        <template v-slot:photo-opt="{ row }">
          <div>
            <i class="el-icon-picture-outline tool-btn" @click="photo(row)"></i>
          </div>
        </template>
        <template v-slot:opt="{ row }">
          <div>
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </div>
        </template>
      </vxe-grid>
      <AddIssues
        ref="addIssues"
        v-if="issuesVisible"
        :visible.sync="issuesVisible"
        :issueType="'A'"
        :title="$l('drawer_label_selectDefectIssues') || '疵点问题选择'"
        @confirm="confirm"
      />

      <IssuesImage
        v-if="editPhotoOpts.visible"
        :title="$l('dialog_inspection_defect_title_issuesImage') || '疵点图片'"
        :disabled="disabled"
        :visible="editPhotoOpts.visible"
        :inspectionCode="editPhotoOpts.inspectionCode"
        :inspectionDefectCode="editPhotoOpts.inspectionDefectCode"
        @closeImage="editPhotoOpts.visible = false"
      />
    </div>
  </div>
</template>
<script>
import lodash from 'lodash'
import { add } from '@/libs/util.number.js'
import EditLoading from '@/mixins/edit-loading'
import AddIssues from '../add-issues'
import IssuesImage from '../../../sample-image'
export default {
  components: {
    AddIssues,
    IssuesImage,
  },
  mixins: [EditLoading],

  props: {
    inspectionDefectList: {
      type: Array,
      default: () => [],
    },
    disabled: { type: Boolean, default: false },
    inspectionDetailCode: { type: String, default: '' },
  },

  data() {
    return {
      issuesVisible: false,
      tableData: [],
      formData: { identifyNo: '' },
      validRules: {},
      editPhotoOpts: {
        visible: false,
        inspectionCode: '',
        inspectionDefectCode: '',
      },
      tableColumns: [
        {
          field: 'seq',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'defectIssuesTitle',
          headerAlign: 'center',
          align: 'center',
          minWidth: 150,
          title: this.$l('table_label_defectIssuesTitle') || '疵点',
        },
        {
          field: 'quantity',
          headerAlign: 'center',
          align: 'center',
          minWidth: 150,
          title: this.$l('table_label_quantity') || '数量',
          isTotalColumn: true,
        },
        {
          field: 'subQuantity',
          headerAlign: 'center',
          align: 'center',
          width: 100,
          title: this.$l('table_label_subQuantity') || '减数量',
          slots: {
            default: 'subQuantity',
          },
          visible: !this.disabled,
        },
        {
          field: 'addQuantity',
          headerAlign: 'center',
          align: 'center',
          width: 100,
          title: this.$l('table_label_addQuantity') || '加数量',
          slots: {
            default: 'addQuantity',
          },
          visible: !this.disabled,
        },
        {
          title: this.$l('table_label_deductScore') || '扣分数',
          field: 'deductScore',
          align: 'center',
          minWidth: 150,
          editRender: {
            name: 'ElInputNumber',
            immediate: true,
            props: {
              min: 0,
              step: 1,
              precision: 0,
              controls: false,
            },
            events: { blur: this.deductScoreBlur },
          },
          isTotalColumn: true,
        },
        {
          field: 'photo-opt',
          title: this.$l('INDEX.table_label_image') || '图片',
          align: 'center',
          width: 100,
          slots: { default: 'photo-opt' },
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'center',
          width: 100,
          slots: {
            default: 'opt',
          },
          visible: !this.disabled,
        },
      ],
    }
  },
  watch: {
    inspectionDefectList: {
      handler(val) {
        if (val) this.tableData = lodash.cloneDeep(val)
      },
      immediate: true,
    },
  },
  computed: {
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)
      const { tableData } = this.$refs.table.getTableData()

      const totalColumnValues = tableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns
        .filter((c) => c.visible != false)
        .map((t) => totalColumnValues[t.field] || '')
      result[1] = this.$l('INDEX.total') || '合计'
      this.$emit('changeDefectTotalCount', result[2])
      return [result]
    },
  },

  methods: {
    getTableData() {
      const { tableData } = this.$refs.table.getTableData()
      return tableData.map((row) => {
        return {
          ...row,
        }
      })
    },
    openEditDrawer() {
      this.issuesVisible = true
    },
    async confirm(items, isIncremental = true) {
      this.loadingOpen()
      await this.$api
        .fabricInspectionDefectSaveApi({
          inspectionDetailCode: this.inspectionDetailCode,
          issueType: 'A',
          inspectionDefectList: items,
          isIncremental,
        })
        .then((res) => {
          this.loadingClose()
          if (!res) return
          const { status, msg } = res
          if (200 !== status) {
            this.$message({
              showClose: true,
              message: msg || '系统异常',
              type: 'error',
            })
            return
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error('保存失败！')
        })

      this.issuesVisible = false
      this.$emit('reloadDefectList')
    },
    async del(row) {
      await this.delDefectApi({
        inspectionDefectCode: row.inspectionDefectCode,
        issueType: 'A',
        del: true,
      })
    },
    photo({ inspectionCode, inspectionDefectCode } = {}) {
      this.editPhotoOpts = {
        visible: true,
        inspectionCode,
        inspectionDefectCode,
      }
    },
    async subQuantity(row) {
      await this.delDefectApi({
        inspectionDefectCode: row.inspectionDefectCode,
        issueType: 'A',
        del: false,
      })
    },

    async delDefectApi({ inspectionDefectCode, issueType, del = true }) {
      this.loadingOpen()
      this.$api
        .fabricInspectionDefectDelApi({
          inspectionDefectCode,
          issueType,
          del,
        })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
            return
          }
          this.$message({
            message: '操作成功！',
            type: 'success',
          })
          this.$emit('reloadDefectList')
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        })
    },
    deductScoreBlur({ row, column }) {
      const isUpdate = this.$refs.table.isUpdateByRow(row, column.property)
      if (!isUpdate) return

      const deductScore = row.deductScore || 0
      this.confirm([{ ...row, deductScore }], false)
    },
  },
}
</script>
